module.exports = __webpack_public_path__ + "static/media/460GriffinStNW_2018-06-05_29.26e2f7f0.jpg";